<script>
import SortingAnchorTag from '../../../../../../../Pages/components/sorting/TableColumnSortAnchorTag.vue';
import { eventBus } from '../../../../../../../Pages/assets/eventBus';
import { piniaPlugin } from '../../../../../../../Pages/stores';
import Swal from "sweetalert2";
import axios from "axios";
import { Inertia } from '@inertiajs/inertia';
export default {
    components: { SortingAnchorTag },
    data() {
        return {
            isEdit: false,
            renameFolderFile: {
                doc_name: null,
                file_name: null,
                doc_id: 0,
                ext: null,
                dataType: null
            },
            click: 0
        }
    },
    props: {
        allItems: {
            type: Array,
            default: [],
            required: true,
        },
        columns: {
            type: Array,
            default: [],
            required: true,
        },
        sortParam: {
            type: String,
            default: null,
        },
        isLoading: Boolean,
        activeSortedColumn: {
            type: String,
            default: null,
        },
        noDataTitle: {
            type: String,
            default: null,
            required: true,
        },
        classes: {
            type: String,
            required: true
        },
        increment: {
            type: Number,
            required: true
        },
        isDataLoading: {
            type: Boolean,
            required: true
        },
        onMounted: {
            type: Function,
            required: true
        },
        perpage: {
            type: Number,
            default: 12,
            required: true
        },
        showModal: {
            type: Function,
            required: true
        },
        routeType: {
            type: String,
            default: null
        },
        dataType: {
            type: String,
            default: null,
        }
    },
    setup() {
        const store = piniaPlugin();
        return { store };
    },
    computed: {
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        },
        hideScrollable() {
            if(this.perpage == 12 && this.allItems.length < 13 || this.perpage == 24 && this.allItems.length < 25 || this.perpage == 36 && this.allItems.length < 37 || this.perpage == 48 && this.allItems.length < 49) {
                return true
            }
        },
        userType() {
            return this.$page.props.auth.user.user_type;
        }
    },
    methods: {
        renameFolderFileData() {
            let type = this.renameFolderFile.dataType
            let URL = (type === 'files') ? route(this.userTypeAbbr + '-vault-rename-data-file') : route(this.userTypeAbbr + '-vault-document-rename')
            this.$refs.topProgress.start()
            axios.post(URL, this.renameFolderFile, {})
            .then(response => {
                if(response.data.success == true) {
                    eventBus.reloadFolderFile('Rename', this.renameFolderFile.dataType);
                    this.isEdit = false
                    this.$toastr.s(response.data.message)
                }
                else {
                    this.$toastr.e(response.data.message) 
                }
                this.$refs.topProgress.done()
            })
            .catch(err => {
                this.$toastr.e(err.message);
                this.$refs.topProgress.done()
            })
        },
        editMode(val, name, docid, type) {
            this.isEdit = val 
            this.renameFolderFile.doc_name = name
            this.renameFolderFile.file_name = name.split(".")[0]
            this.renameFolderFile.ext = name.split(".")[1]
            this.renameFolderFile.doc_id = docid
            this.renameFolderFile.dataType = type
            setTimeout(() => {
                this.focusMe()
            }, 1000)
        },
        disableEditMode(val) {
            if(val == true){
                this.renameFolderFile.dataType === 'files' ? (this.renameFolderFile.file_name = this.renameFolderFile.file_name.trim()) : (this.renameFolderFile.doc_name = this.renameFolderFile.doc_name.trim())
                if(this.renameFolderFile.dataType === 'files' && this.renameFolderFile.file_name != '' || this.renameFolderFile.dataType === 'folders' && this.renameFolderFile.doc_name != '') {
                    this.renameFolderFileData()
                }
            } else {
                setTimeout(() => {
                    this.isEdit = false
                }, 500)
            }
        },
        focusMe() {
            this.$refs.rename[0].focus()
        },
        checkClickEvent(item, event, value = 0) {
            let val = 1

            if(!this.isEdit && value == 0) {
                this.click += val
            }

            setTimeout(() => {
                let filesFolderLength = (item.dataType == 'files') ? item.name.split(".").slice(0, -1).join(".").length : item.name.length;
                let isNameTruncated = false;
                if (!this.isEdit && value == 1) {
                    isNameTruncated = event.target.innerHTML.split(" ").includes("...")
                }

                if (this.click == 1 && value == 1 && filesFolderLength > 30 && isNameTruncated) {
                    event.target.innerHTML = item.name;
                }
                else {
                    if (this.click == 1) {
                        if (this.routeType === 'Trash') {
                            this.store.useTrashStore.restoreFolderFile(this.userTypeAbbr, item, "takeOutOfTrash");
                        }
                        else if ((('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword)) {
                            this.showModal(`Confirm password to unlock ''${item.name}''`, 'unlock', item)
                        }
                        else {
                            localStorage.getID = JSON.stringify(item.id);
                            (item.dataType == 'files') ? window.open(item.viewUrl, '_blank') : Inertia.visit(item.viewUrl)
                        }
                    }
                    else if (this.click == 2 && item.isEditDeleteUpload && !(('hasPassword' in item) && item.hasPassword)) {
                        this.editMode(true, item.name, item.id, item.dataType)
                    }
                }
                this.click = 0
            }, 500)
        }
    },
    mounted() {
        let self = this
        self.onMounted('setincrement')
    }
    
};
</script>

<template>
    <div>
        <div class="setListHeight" :class="{scrollableBody: (allItems.length > 12), hideScrollBar: hideScrollable, listInfiniteData: (classes == 'files'), gridInfiniteData: (classes == 'folders')}">
            <div class="table-responsive">
                <vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
                <table class="table table-centered table-nowrap table-hover mb-0 document-manager-td">
                    <thead>
                        <tr>
                            <th v-for="(item, index) in columns" :key="index" scope="col">
                                {{ item.name }}
                                <SortingAnchorTag 
                                    v-if="item.sortASC != null"
                                    :disabledAsc="activeSortedColumn === item.sortASC"
                                    :disabledDesc="activeSortedColumn === item.sortDESC"
                                    :sortParam="sortParam"
                                    :ascSortValue="item.sortASC" 
                                    :descSortValue="item.sortDESC" 
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="allItems.length > 0">
                        <tr v-for="(item, index) in allItems.slice(0, increment)" :key="index">
                            <td>
                                <a v-if="item.dataType === 'files'" @click="checkClickEvent(item, $event)" href="javascript:void(0)" class="text-dark fw-medium">       
                                    <span v-if="isEdit == true && renameFolderFile.doc_id == item.id">
                                        <form @submit.prevent="disableEditMode(true)">
                                            <div class="input-group">
                                                <i class="mdi mdi-file-document font-size-16 align-middle text-primary me-2" :class="item.listDocIcon"></i>
                                                <input ref="rename" class="form-control border border-0 border-bottom rounded-0 border-primary border-2 p-0" placeholder="Enter new name" required v-model="renameFolderFile.file_name"/>
                                                <div class="input-group-addon">
                                                    <button type="submit" class="btn-custom"><i class="font-size-20 text-success mdi mdi-check"></i></button>
                                                    <i @click="disableEditMode(false)" class="font-size-20 text-danger mdi mdi-close"></i>
                                                </div>
                                            </div>
                                        </form>
                                    </span>
                                    <span class="d-flex align-items-center text-break gap-1" v-else> 
                                        <template v-if="(!(('protected' in item) && item.protected) && item.isEditDeleteUpload) || item.docType === 'Normal' || item.docType === 'Vault'">
                                            <input 
                                                v-if="!(('hasPassword' in item) && item.hasPassword)"
                                                @click.stop 
                                                class="me-1 multipleSelect" 
                                                role="button" 
                                                type="checkbox"
                                                :value="{ id: item.encryptedId, dataType: item.dataType, type: item.type }"
                                                v-model="store.useMultiSelect.selectedItems"
                                            >
                                        </template>
                                        <i class="mdi mdi-file-document font-size-16 align-middle text-primary me-2" :class="item.listDocIcon"></i>
                                        <div @click="checkClickEvent(item, $event, 1)">{{ item.name.split(".").slice(0, -1).join(".").length > 30 ? `${item.name.split(".").slice(0, -1).join(".").substring(0, 30).concat('  ...')}` : item.name }}</div>                       
                                        <i v-if="(('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword)" class="mdi mdi-lock text-secondary"></i>
                                    </span>                                  
                                </a>
                                <a v-else @click="checkClickEvent(item, $event)" href="javascript:void(0)" class="text-dark fw-medium">
                                    <span v-if="isEdit == true && renameFolderFile.doc_id == item.id">
                                        <form @submit.prevent="disableEditMode(true)">
                                            <div class="input-group">
                                                <i class="mdi-folder mdi mdi-file-document font-size-16 align-middle me-2" :class="dataType === 'Own' || dataType === 'OwnContent' ? 'text-warning' : 'text-primary'"></i>
                                                <input ref="rename" class="form-control border border-0 border-bottom rounded-0 border-primary border-2 p-0" placeholder="Enter new name" required v-model="renameFolderFile.doc_name"/>
                                                <div class="input-group-addon">
                                                    <button type="submit" class="btn-custom"><i class="font-size-20 text-success mdi mdi-check"></i></button>
                                                    <i @click="disableEditMode(false)" class="font-size-20 text-danger mdi mdi-close"></i>
                                                </div>
                                            </div>
                                        </form>
                                    </span>
                                    <span class="d-flex align-items-center text-break gap-1" v-else> 
                                        <template v-if="(!(('protected' in item) && item.protected) && item.isEditDeleteUpload) || item.docType === 'Normal' || item.docType === 'Vault'">
                                            <input 
                                                v-if="!(('hasPassword' in item) && item.hasPassword)"
                                                @click.stop 
                                                class="me-1 multipleSelect" 
                                                role="button" 
                                                type="checkbox"
                                                :value="{ id: item.encryptedId, dataType: item.dataType, type: item.type }"
                                                v-model="store.useMultiSelect.selectedItems"
                                            >
                                        </template>
                                        <i class="mdi-folder mdi mdi-file-document font-size-16 align-middle me-2" :class="dataType === 'Own' || dataType === 'OwnContent' ? 'text-warning' : 'text-primary'"></i> 
                                        <div @click="checkClickEvent(item, $event, 1)">{{ item.name.length > 30 ? `${item.name.substring(0, 30).concat('  ...')}` : item.name }}</div> 
                                        <i v-if="(('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword)" class="mdi mdi-lock text-secondary"></i>
                                    </span>
                                </a>
                            </td>
                            <td>{{ item.created_at }}</td>
                            <td>{{ item.size }}</td>
                            <td v-if="item.sharedBy">{{ item.sharedBy }}</td>
                            <td v-if="item.isEditDeleteUpload || (!item.isEditDeleteUpload && !(('hasPassword' in item) && item.hasPassword))">
                                <b-dropdown
                                    toggle-class="font-size-16 text-muted p-0"
                                    variant="white"
                                    menu-class="dropdown-menu-end"
                                    right
                                >
                                    <template #button-content>
                                        <i class="mdi mdi-dots-horizontal"></i>
                                    </template>
                                    <template v-if="routeType === 'Trash'">
                                        <b-dropdown-item href="javascript:void(0)" @click="store.useTrashStore.restoreFolderFile(userTypeAbbr, item)">Restore</b-dropdown-item>
                                        <b-dropdown-item href="javascript:void(0)" @click="store.useTrashStore.deleteFolderFile(userTypeAbbr, item)">Delete forever</b-dropdown-item>
                                    </template>
                                    <template v-else>
                                        <template v-if="item.docType === 'own' && item.isEditDeleteUpload">
                                            <template v-if="!(('protected' in item) && item.protected)">
                                                <b-dropdown-item v-if="!(('hasPassword' in item) && item.hasPassword)" @click="editMode(true, item.name, item.id, item.dataType)" href="javascript:void(0)">Rename</b-dropdown-item>
                                                <b-dropdown-item href="javascript:void(0)" @click="showModal(`Set a password to protect ''${item.name}''`, 'protect', item)">Protect</b-dropdown-item>
                                                <b-dropdown-item v-if="!(('hasPassword' in item) && item.hasPassword)" href="Javascript:void(0)" @click="store.useMoveStore.showMoveModal(item)">Move</b-dropdown-item>
                                                <template v-if="userType != 4">
                                                    <b-dropdown-item v-if="!(('hasPassword' in item) && item.hasPassword)" href="Javascript:void(0)" @click="store.useDeleteStore.multipleDeleteFolderFile(userTypeAbbr, item)">Delete</b-dropdown-item>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <b-dropdown-item href="javascript:void(0)" @click="showModal(`Confirm password to unprotect ''${item.name}''`, 'unprotect', item)">Unprotect</b-dropdown-item>
                                                <b-dropdown-item href="javascript:void(0)" @click="showModal(`Change Password for ''${item.name}''`, 'changePassword', item)">Change Password</b-dropdown-item>
                                                <b-dropdown-item href="javascript:void(0)" @click="showModal('Confirm profile password for recovery', 'forgotmatch', item)">Forgot Password</b-dropdown-item>
                                            </template>
                                        </template>
                                        <b-dropdown-item v-if="item.dataType === 'folders' && !(('hasPassword' in item) && item.hasPassword)" href="javascript:void(0)" @click="store.useDownloadStore.downloadFoldersFiles(item.encryptedId, item)">Download</b-dropdown-item>
                                        <b-dropdown-item v-if="item.dataType === 'files' && !(('hasPassword' in item) && item.hasPassword)" :href="item.viewUrl" :download="item.name">Download</b-dropdown-item>
                                    </template>  
                                </b-dropdown>
                            </td>
                            <td v-else>--</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td :colspan="columns.length">
                                <div class="text-center text-secondary">
                                    <span v-html="noDataTitle"></span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="isDataLoading"  class="col-12">
            <div class="text-center my-3">
                <a href="javascript:void(0);" class="text-success"><i class="bx bx-hourglass bx-spin me-2"></i> Loading</a>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .scrollableBody {
      overflow-y: scroll;
    }

    .scrollableBody thead th{
        position: sticky;
        top:0;
        background-color: #ffffff;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    .hideScrollBar::-webkit-scrollbar {
        display: none;
    }
    .hideScrollBar {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .btn-custom {
        background-color: transparent;
        border: none;
        outline: none;
        padding:0.1rem;
        margin:0;
    }
    .document-manager-td td {
        word-wrap: break-word;
        white-space: normal !important;
    }
    .document-manager-td td:first-child {
        min-width: 20%;
    }
    .fixed-width-text {
        width:300px;
    }
</style>
